export class Oui {

	public mesuresConfurlConfidentialite: string;

	constructor() { 
		 		this.mesuresConfurlConfidentialite = '';
 
	}
}
